import { render, staticRenderFns } from "./password.vue?vue&type=template&id=21fd4d7a&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=21fd4d7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd4d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fd4d7a')) {
      api.createRecord('21fd4d7a', component.options)
    } else {
      api.reload('21fd4d7a', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=21fd4d7a&scoped=true", function () {
      api.rerender('21fd4d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/workbench/components/password.vue"
export default component.exports